/**
 * Length of a serialized-markdown string as counted by the RichTextEditor's
 * `markdownLimit` hard limit (and by the media-metadata / central backends).
 *
 * A hard line break (shift+enter) counts as a single character, so collapse it
 * before measuring. The editor serializes it as `\` + newline, while a value
 * loaded back from the backend uses the two-space + newline form — normalize both
 * so the counter (editor `getMarkdown()`) and Yup validation (raw form value,
 * which on reload is the backend form) agree, and both stay in lockstep with
 * resi-ui's `markdownLimit` (which collapses `\` + newline the same way).
 */
const getMarkdownLimitLength = (markdown: string): number => markdown.replace(/(?:\\|  )\n/g, '\n').length;

export default getMarkdownLimitLength;
